export function capitalize(str: string): string {
	const text = (str || '').trim();
	const first = text.substring(0, 1);
	const rest = text.substring(1);
	return `${first.toUpperCase()}${rest}`;
}
